import script from "./ModuleNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleNavigation.vue?vue&type=style&index=0&id=cdb3ad60&lang=scss"

const __exports__ = script;

export default __exports__